import { createFileRoute } from "@tanstack/react-router";
import { CORRIDORS, CorridorPage, corridorHead } from "@/lib/corridors";

const corridor = CORRIDORS["marrakech-to-agadir"];

export const Route = createFileRoute("/transfers/marrakech-to-agadir")({
  head: () => corridorHead(corridor),
  component: () => <CorridorPage corridor={corridor} />,
});
